import importComponent, { render } from './helpers/bootstrap';
import { ENDPOINT } from './constants';
import global from './components/global';

$(() => {
  // Globals
  ////////////////
  global();
  $('.wh-insights-slider-item__title').dotdotdot({
    watch: 'window'
  })

  $('.wh-recent-news-item__title').dotdotdot({
    watch: 'window',
    height: 100
  });

  // On demand
  ////////////////
  importComponent('global/SectionNav', '.wh-section-nav')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('people/PeopleHeader', '.wh-people-header')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component(el);
    });

  importComponent('RecognitionListing', '.wh-recognition-details')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('solution/InsightsRow', '.wh-insights-row')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        if (window.matchMedia('(min-width: 1100px)').matches) return;
        new component($target);
      });
    });

  importComponent('solution/FeaturedLinksRow', '.wh-featured-links-row')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        if (window.matchMedia('(min-width: 1100px)').matches) return;
        new component($target);
      });
    });

  importComponent('ExperienceListing', '.wh-experience-listing')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('InsightsListing', '.wh-insights-listing')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target, {
          template: {
            item: require('templates/insights-listing-item'),
            tab: require('templates/insights-listing-tab')
          },
          endpoint: {
            getInsightsListing: ENDPOINT.getInsightsListing,
            getInsightsListingVisibility: ENDPOINT.getInsightsListingVisibility
          },
          pagesize: 3
        });
      });
    });

  importComponent('Accordion', '.wh-accordion')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('event-listing/SubscribeCallout', '.wh-subscribe-callout')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('InsightsSlider', '.wh-insights-slider')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('global/StickyHeader', '.wh-sticky-header')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target, {
          progressBarContent: '.wh-scroll-progress__content',
          endpoint: ENDPOINT.getPdfPage
        });
      });
    });

  importComponent('ReadMore', '.wh-content-readmore')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('solution/GeographicReach', '.wh-geographic-reach')
    .then(data => {
      if (!data) return;
      if (window.matchMedia('(max-width: 767px)').matches) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('article/ArticleBrief', '.wh-article-brief')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('article/ArticleSeeMore', '.wh-article-body--seemore')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('global/TwoColumns', '.row--cols2')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('Statistics', '.wh-statistics')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent(['people/Search', 'people/PredictiveSearch'], '.wh-people-search')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        template: require('templates/search-people-item.html'),
        predictiveEndpoint: ENDPOINT.getBioKeywordSearch,
        endpoint: ENDPOINT.getPeopleSearchResults,
        pagesize: {
          list: 30
        },
        PredictiveSearch: component[1]
      });
    });

  importComponent(['insights/Search', 'insights/PredictiveSearch'], '.wh-insights-search')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        template: {
          all: require('templates/search-insights-item.html'),
          blog: require('templates/search-insights-blog-item.html')
        },
        endpoint: ENDPOINT.getInsightsSearchResults,
        predictiveEndpoint: ENDPOINT.getInsightsPredictive,
        pagesize: {
          list: 30
        },
        PredictiveSearch: component[1]
      });
    });

  importComponent(['insights/Search', 'newsroom/PredictiveSearch'], '.wh-new-search--newsroom')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        template: require('templates/search-item.html'),
        endpoint: ENDPOINT.getInsightsSearchResults,
        predictiveEndpoint: ENDPOINT.getInsightsPredictive,
        pagesize: 30,
        PredictiveSearch: component[1]
      });
    });

  importComponent(['newslisting/Search', 'newslisting/PredictiveSearch'], '.wh-new-search--listing')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        template: {
          all: require('templates/search-insights-item.html')

        },
        endpoint: ENDPOINT.getInsightsSearchResults,
        predictiveEndpoint: ENDPOINT.getInsightsPredictive,
        pagesize: {
          list: 30
        },
        PredictiveSearch: component[1]
      });
    });

  importComponent(['search-listing/Search', 'search-listing/PredictiveSearch'], '.wh-new-search-listing--listing')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        template: {
          all: require('templates/search-listing-item.html')

        },
        endpoint: ENDPOINT.getSearchResults,
        predictiveEndpoint: ENDPOINT.getKeywordSearch,
        pagesize: {
          list: 30
        },
        PredictiveSearch: component[1]
      });
    });

    importComponent('event/EventVideoPlayer', '.event-video-player')
    .then(data => {
      if (!data) return;
      const { component, el } = data;
      render(el, $target => {
        new component($target);
      });
    });

  importComponent(['insights-listing/Search', 'insights-listing/NewPredictiveSearch'], '.wh-new-insights-search--listing')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        template: {
          all: require('templates/search-insights-item.html')
        },
        endpoint: ENDPOINT.getInsightsSearchResults,
        predictiveEndpoint: ENDPOINT.getInsightsPredictive,
        pagesize: 30,
        PredictiveSearch: component[1]
      });
    });

  importComponent(['insights-events/PredictiveSearch'], '.wh-insight-events-search')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        template: require('templates/search-insights-item.html'),
        predictiveEventsEndpoint: ENDPOINT.getEventsPredictive,
        predictiveInsightsEndpoint: ENDPOINT.getInsightsPredictive,
        pagesize: 30,
        PredictiveSearch: component[1]
      });
    });

  importComponent(['event-listing/Search', 'event-listing/PredictiveSearch'], '.wh-new-events-search--listing')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        template: {
          all: require('templates/search-events-item.html')
        },
        endpoint: ENDPOINT.getEventsListing,
        predictiveEndpoint: ENDPOINT.getInsightsPredictive,
        pagesize: 30,
        PredictiveSearch: component[1]
      });
    });

  importComponent(['search/Search', 'search/PredictiveSearch'], '.wh-global-search')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        template: require('templates/search-item.html'),
        endpoint: ENDPOINT.getSearchResults,
        tabsEndpoint: ENDPOINT.getSearchResultsTabs,
        pagesize: 30,
        PredictiveSearch: component[1]
      });
    });

  importComponent('about/AboutOverviewNav', '.wh-about-overview-nav__select')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('ShowcaseCarousel', '.wh-showcase-carousel')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent(['HomepageHero', 'global/PredictiveSearch'], '.wh-home-page-hero')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      new component[0](el, {
        PredictiveSearch: component[1],
        interval: 7000
      });
    });

  importComponent('HomepageFeaturedContent', '.homepage-featured-content')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('article/ArticleFootnotes', '.wh-article-body')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('careers/FeaturedContentCarousel', '.featured-content-carousel')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('book/ReviewsTestimonials', '.wh-reviews-testimonials')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('book/Author', '.wh-author__content')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('global/ShareThis', '.wh-sticky-header-sharethis')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('global/ShareComponent', '.share-component')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('global/BackToTop', '.wh-back-to-top')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('about/VideoGrid', '.wh-video-grid')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('BlogListing', '.wh-blog-listing')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target, {
          template: require('templates/blog-listing-item'),
          endpoint: ENDPOINT.getBlogListing,
          pagesize: 18
        });
      });
    });

  importComponent('careers/JobListing', '.wh-job-listing')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target, {
          template: require('templates/job-listing-item'),
          endpoint: ENDPOINT.getJobListing,
          pagesize: 18
        });
      });
    });

  importComponent('ContactsListing', '.wh-contact-us-listing')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target.closest('[role="main"]'), {
          template: require('templates/contact-group-listing'),
          endpoint: ENDPOINT.getContactListing
        });
      });
    });

  importComponent('NoteworthyContent', '.wh-noteworthy-content')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('NewsArticle', '.wh-article-hero')
    .then(data => {
      if (!data) return;
      const { component, el } = data;

      render(el, $target => {
        new component($target);
      });
    });

  importComponent('BioOverview', '.wh-bio-overview')
  .then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => {
      new component($target);
    });
  });

  importComponent('TeamSpotlightGrid', '.team-spotlight-grid')
  .then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => {
      new component($target);
    });
  });

  importComponent('FeaturedSolutionSlider', '.featured-solution')
  .then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => {
      new component($target);
    });
  });

  importComponent('TestimonialCarousel', '.testimonial-carousel')
  .then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => {
      new component($target);
    });
  });

  importComponent('CaseStudySpotlight', '.case-study')
  .then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => {
      new component($target);
    });
  });

  importComponent('ColumnCareersRow', '.column-careers-row')
  .then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => {
      new component($target);
    });
  });

  importComponent('HomepageMasthead', '.homepage-masthead')
  .then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => {
      new component($target);
    });
  });

  importComponent('TrendingTopicsCarousel', '.trending-topics-carousel')
  .then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => {
      new component($target);
    });
  });

  importComponent('report/ReportStickyNavigation', '.report-sticky-navigation')
  .then(data => {
    if (!data) return;
    const { component, el } = data;

    render(el, $target => {
      new component($target);
    });
  });
});



// WEBPACK FOOTER //
// ./src/js/main.js